import * as Sentry from '@sentry/react';

const isProduction = import.meta.env.VITE_ENV === 'production';

if (import.meta.env.VITE_SENTRY_ENABLED === 'true') {
  Sentry.init({
    dsn: 'https://6915c95eb4e5ae44c685c450c7a500b3@o4509289298591744.ingest.us.sentry.io/4509289364717568',
    environment: import.meta.env.VITE_ENV,
    integrations: [
      // send console.error, and console.warn calls as logs to Sentry
      Sentry.consoleLoggingIntegration({
        levels: [
          'debug',
          'info',
          'log',
          'error',
          'warn',
        ],
      }),
      Sentry.replayIntegration({
        blockAllMedia: false,
        maskAllInputs: false,
        maskAllText: false,
      }),
      Sentry.feedbackIntegration({
        autoInject: false,
        colorScheme: 'light',
        formTitle: 'Give Feedback',
        messagePlaceholder: 'What do you want to report?',
        submitButtonLabel: 'Submit Feedback',
        successMessageText: 'Thank you for your feedback!',
        triggerLabel: 'Report Feedback',
      }),
    ],
    // Only capture replays in production
    replaysOnErrorSampleRate: isProduction ? 1 : 0,
    replaysSessionSampleRate: isProduction ? 1 : 0,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  });

  // Set up anonymous user tracking immediately
  // This creates a session that can later be linked to the authenticated user
  const anonymousUserId = `anonymous-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
  Sentry.setUser({
    id: anonymousUserId,
  });
  Sentry.setTag('session_type', 'anonymous');
}
